
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(1009),
  areaId: Number.withConstraint(x => x >= 0),
  kingdomId: Number.withConstraint(x => x >= 0 && x <= 1000),
  playerId: Number,
  posX: Number.withConstraint(x => x >= -1 && x <= 10000),
  posY: Number.withConstraint(x => x >= -1 && x <= 10000),
}).And(Partial({
  reason: Number.withConstraint(x => x >= 0 && x <= 100),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(1009),
  areaId: Number.withConstraint(x => x >= 0),
  kingdomId: Number.withConstraint(x => x >= 0 && x <= 1000),
  playerId: Number,
  posX: Number.withConstraint(x => x >= -1 && x <= 10000),
  posY: Number.withConstraint(x => x >= -1 && x <= 10000),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
}).And(Partial({
  reason: Number.withConstraint(x => x >= 0 && x <= 100),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  zoneId: Number,
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 1009;
  